<template>
  <div v-if="project != null">
    <h1>CONDICIONES PARA EL TELETRABAJO</h1>
    <table class="table" >
      <thead>
        <tr>
          <th scope="col">CONDICIONES PARA EL TELETRABAJO</th>
          <th scope="col">DESCRIPCIÓN</th>
          <th scope="col">¿ SON ADECUADAS ?</th>
        </tr>        
      </thead>
      <tbody>
        <tr>
          <td width="20%;">
            ¿Realizará el teletrabajo en su vivienda? Si – No. Dónde?
          </td>
          <td width="60%;">
            <input type="text" name="would_make_telework_description" class="form-control" id="would_make_telework_description" placeholder="" v-model="project.would_make_telework_description"/>
          </td>
          <td>
            <input type="checkbox" class="form-check-input" id="would_make_telework_suitable" v-model="project.would_make_telework_suitable">
            <label class="form-check-label" for="exampleCheck1" v-if="project.would_make_telework_suitable">Si</label>
            <label class="form-check-label" for="exampleCheck1" v-if="!project.would_make_telework_suitable">No</label>
          </td>
        </tr>
        <tr>
          <td width="20%;">
            Descripción del espacio
          </td>
          <td width="60%;">
            <input type="text" name="telework_place_description" class="form-control" id="telework_place_description" placeholder="" v-model="project.telework_place_description"/>
          </td>
          <td>
            <input type="checkbox" class="form-check-input" id="telework_place_description_suitable" v-model="project.telework_place_suitable">
            <label class="form-check-label" for="exampleCheck1" v-if="project.telework_place_suitable">Si</label>
            <label class="form-check-label" for="exampleCheck1" v-if="!project.telework_place_suitable">No</label>
          </td>
        </tr>
        <tr>
          <td width="20%;">
            Equipos para teletrabajar herramientas y puesto de trabajo
          </td>
          <td width="60%;">
            <input type="text" name="telework_place_tools" class="form-control" id="telework_place_tools" placeholder="" v-model="project.telework_place_tools"/>
          </td>
          <td>
            <input type="checkbox" class="form-check-input" id="telework_place_tools_suitable" v-model="project.telework_place_tools_suitable">
            <label class="form-check-label" for="exampleCheck1" v-if="project.telework_place_tools_suitable">Si</label>
            <label class="form-check-label" for="exampleCheck1" v-if="!project.telework_place_tools_suitable">No</label>
          </td>
        </tr>
        <tr>
          <td width="20%;">
            Condiciones ambientales en cuanto a iluminación, atmosféricas y sonoras adecuadas
          </td>
          <td width="60%;">
            <input type="text" name="telework_place_environment" class="form-control" id="telework_place_environment" placeholder="" v-model="project.telework_place_environment"/>
          </td>
          <td>
            <input type="checkbox" class="form-check-input" id="telework_place_environment_suitable" v-model="project.telework_place_environment_suitable">
            <label class="form-check-label" for="exampleCheck1" v-if="project.telework_place_environment_suitable">Si</label>
            <label class="form-check-label" for="exampleCheck1" v-if="!project.telework_place_environment_suitable">No</label>
          </td>
        </tr>
        <tr>
          <td width="20%;">
            Condiciones de tecnología y conectividad (Computador, energía, conexión, etc)
          </td>
          <td width="60%;">
            <input type="text" name="telework_place_description" class="form-control" id="telework_place_technology" placeholder="" v-model="project.telework_place_technology"/>
          </td>
          <td>
            <input type="checkbox" class="form-check-input" id="telework_place_technology_suitable" v-model="project.telework_place_technology_suitable">
            <label class="form-check-label" for="exampleCheck1" v-if="project.telework_place_technology_suitable">Si</label>
            <label class="form-check-label" for="exampleCheck1" v-if="!project.telework_place_technology_suitable">No</label>
          </td>
        </tr>
        <tr>
          <td width="20%;">
            Condiciones de concentración y disponibilidad para teletrabajar
          </td>
          <td width="60%;">
            <input type="text" name="telework_place_concentration_suitable" class="form-control" id="telework_place_concentration_suitable" placeholder="" v-model="project.telework_place_concentration"/>
          </td>
          <td>
            <input type="checkbox" class="form-check-input" id="telework_place_concentration_suitable" v-model="project.telework_place_concentration_suitable">
            <label class="form-check-label" for="exampleCheck1" v-if="project.telework_place_concentration_suitable">Si</label>
            <label class="form-check-label" for="exampleCheck1" v-if="!project.telework_place_concentration_suitable">No</label>
          </td>
        </tr>                        
      </tbody>
    </table>
    <b-button variant="primary" @click.prevent="save">Guardar</b-button>
		<div :class="`alert ${typeMessage}`" role="alert" id="message-update" v-if="message != ''">
			{{message}}
		</div>    
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios';
import { mapGetters, mapMutations } from 'vuex'
import SelectLocal from './../../own/select-local.vue'

export default {
  name: 'RemoteWork',
  props: ['project_id', 'assignment_id'],  
  computed: {
    ...mapGetters(['projectId', 'assignmentId', 'project', 'assignment', 'selects'])
  },  
  data() {
    return {
			message: '',
			typeMessage: ''
    }
  },
  components: {
    'select-local': SelectLocal,
  },  
  methods: {
    ...mapMutations(['changeProjectId', 'changeAssignmentId', 'changeProject', 'changeAssignment', 'changeSelects']),
    defaultAxios(){
			var token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
			axios.defaults.headers['x-csrf-token'] = token
			axios.defaults.headers.common['Accept'] = 'application/json';
			axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    },
    getInformationWork() {
      console.log("3***")
			axios.get(`/information_work.json?project_id=${this.project_id}&assignment_id=${this.assignment_id}`).then(res=>{
				if(res.status == 200){
          this.changeProjectId(this.project_id)
          this.changeAssignmentId(this.assignment_id)
          this.changeProject(res.data.project)
          this.changeAssignment(res.data.assignment)
          this.changeSelects(res.data.selects)
				}
			})
    },
    save(){
      this.defaultAxios()
      let project = this.project
      delete project.family_compositions
      delete project.family_references
      delete project.family_sicks
      delete project.family_interviews
      delete project.working_condition
			axios.put(`/update_information_personal`, { project: project }).then(res=>{
				if(res.status == 200){
          this.getInformationWork()
          this.showMessage('Proceso actualizado', 'alert-success')
				}else{
          this.showMessage('El registro no se pudo actualizar', 'alert-danger')
        }
			}, (err) => {
        this.showMessage('El registro no se pudo actualizar', 'alert-danger')
      })
    },
		showMessage(message, typeMessage){
			this.message = message
			this.typeMessage = typeMessage
			setTimeout(() => this.message = '', 3000)
		},        
  },
  created () {

  },
  watch: {
    data(newValue, oldValue) {
      
    }
  },
  filters: {
    fnName: function(value) {
      return value;
    }
  }
}
</script>

<style scoped>

</style>